var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveDirectory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "active-directory_svg__a",
    x1: 13.25,
    y1: 13.02,
    x2: 8.62,
    y2: 4.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1988d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#54aef0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "active-directory_svg__b",
    x1: 11.26,
    y1: 10.47,
    x2: 14.46,
    y2: 15.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#54aef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4fabee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#41a2e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#2a93e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#1988d9"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M1.01 10.19l7.92 5.14 8.06-5.16L18 11.35l-9.07 5.84L0 11.35l1.01-1.16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.61 9.53L8.93.81l7.47 8.73-7.47 4.72-7.32-4.73z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M8.93.81v13.45L1.61 9.53 8.93.81z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#active-directory_svg__a)",
    d: "M8.93.81v13.45l7.47-4.72L8.93.81z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#53b1e0",
    d: "M8.93 7.76l7.47 1.78-7.47 4.72v-6.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cebff",
    d: "M8.93 14.26L1.61 9.53l7.32-1.77v6.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#active-directory_svg__b)",
    d: "M8.93 17.19L18 11.35l-1.01-1.18-8.06 5.16v1.86z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iYmRiNTYzMjktNDcxNy00NDEwLWFhMTMtNDUwNWVjYWE0ZTQ2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImJhMjYxMGMzLWE0NWEtNGU3ZS1hMGMwLTI4NWNmZDdlMDA1ZCIgeDE9IjEzLjI1IiB5MT0iMTMuMDIiIHgyPSI4LjYyIiB5Mj0iNC4yNSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzE5ODhkOSIgLz48c3RvcCBvZmZzZXQ9IjAuOSIgc3RvcC1jb2xvcj0iIzU0YWVmMCIgLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCBpZD0iYmQ4ZjYxOGItNGYyZi00Y2I3LWFmZjAtMmZkMmQyMTEzMjZkIiB4MT0iMTEuMjYiIHkxPSIxMC40NyIgeDI9IjE0LjQ2IiB5Mj0iMTUuOTkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAuMSIgc3RvcC1jb2xvcj0iIzU0YWVmMCIgLz48c3RvcCBvZmZzZXQ9IjAuMjkiIHN0b3AtY29sb3I9IiM0ZmFiZWUiIC8+PHN0b3Agb2Zmc2V0PSIwLjUxIiBzdG9wLWNvbG9yPSIjNDFhMmU5IiAvPjxzdG9wIG9mZnNldD0iMC43NCIgc3RvcC1jb2xvcj0iIzJhOTNlMCIgLz48c3RvcCBvZmZzZXQ9IjAuODgiIHN0b3AtY29sb3I9IiMxOTg4ZDkiIC8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PHRpdGxlPkljb24taWRlbnRpdHktMjIxPC90aXRsZT48cG9seWdvbiBwb2ludHM9IjEuMDEgMTAuMTkgOC45MyAxNS4zMyAxNi45OSAxMC4xNyAxOCAxMS4zNSA4LjkzIDE3LjE5IDAgMTEuMzUgMS4wMSAxMC4xOSIgZmlsbD0iIzUwZTZmZiIgLz48cG9seWdvbiBwb2ludHM9IjEuNjEgOS41MyA4LjkzIDAuODEgMTYuNCA5LjU0IDguOTMgMTQuMjYgMS42MSA5LjUzIiBmaWxsPSIjZmZmIiAvPjxwb2x5Z29uIHBvaW50cz0iOC45MyAwLjgxIDguOTMgMTQuMjYgMS42MSA5LjUzIDguOTMgMC44MSIgZmlsbD0iIzUwZTZmZiIgLz48cG9seWdvbiBwb2ludHM9IjguOTMgMC44MSA4LjkzIDE0LjI2IDE2LjQgOS41NCA4LjkzIDAuODEiIGZpbGw9InVybCgjYmEyNjEwYzMtYTQ1YS00ZTdlLWEwYzAtMjg1Y2ZkN2UwMDVkKSIgLz48cG9seWdvbiBwb2ludHM9IjguOTMgNy43NiAxNi40IDkuNTQgOC45MyAxNC4yNiA4LjkzIDcuNzYiIGZpbGw9IiM1M2IxZTAiIC8+PHBvbHlnb24gcG9pbnRzPSI4LjkzIDE0LjI2IDEuNjEgOS41MyA4LjkzIDcuNzYgOC45MyAxNC4yNiIgZmlsbD0iIzljZWJmZiIgLz48cG9seWdvbiBwb2ludHM9IjguOTMgMTcuMTkgMTggMTEuMzUgMTYuOTkgMTAuMTcgOC45MyAxNS4zMyA4LjkzIDE3LjE5IiBmaWxsPSJ1cmwoI2JkOGY2MThiLTRmMmYtNGNiNy1hZmYwLTJmZDJkMjExMzI2ZCkiIC8+PC9zdmc+";
export { SvgActiveDirectory as ReactComponent };